import { format } from 'date-fns'
import React, { useEffect, useState } from 'react'
import { useQuery, useQueryClient } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import Botao from '../../../components/Mantine/Botao'
import ellipseVerde from '../../../icones/iconesVersaoVerde/ellipse.svg'
import {
  filtrosArrayBarra,
  maximoTagsExibidas,
  mudarFiltros,
  realizouFiltro,
  recarregarBarraFiltragem,
  revelarBarraFiltragem
} from '../../../redux/actions'
import { DispositivosService } from '../../../services/http/dispositivos.service'
import { useGlobal } from '../../../stores/useGlobal'
import { limparFiltr } from '../../../utils/alternanciaIcones'
import {
  formatArrayToString,
  formatDateToDatePicker,
  formatDateToFilter
} from '../../../utils/genericFormatters'

import Filtros from './components/Filtros'
import * as S from './styles'

//#region contants
const DEFAULT_FILTERS_VALUES = {
  OPERADORA: [],
  REDE: [],
  AQUISICAO: {
    DE: null,
    ATE: null
  },
  ATIVACAO: {
    DE: null,
    ATE: null
  },
  ULTIMO_EVENTO: {
    DE: null,
    ATE: null
  }
}

const FILTROS = {
  grupo1: ['OPERADORA', 'REDE', 'STATUS', 'TECNOLOGIA', 'TRAFEGO', 'CONEXOES'],
  grupo2: [
    'ULTIMO_EVENTO',
    'PLANO_TIPO',
    'ENVIO_SMS',
    'TIPO_SIMCARD',
    'PACOTE_EXTRA',
    'PACOTES'
  ],
  grupo3: [
    'VALOR',
    'DIAS_UTILIZADOS',
    'AQUISICAO',
    'ATIVACAO',
    'SERVICOS_ADICIONAIS',
    'CONSUMO'
  ],
  grupo4: [
    'SALDO',
    'ICCID_INTERVALO',
    'MARCA_MODELO',
    'GRUPO',
    'STATUS_CONTRATO',
    'CLIENTE_FINAL'
  ]
}

const MOCK_FILTROS = {
  OPERADORA: [],
  REDE: [],
  SIMCARD_TIPO: [],
  GRUPOS: [],
  STATUS: [
    { label: 'Online', value: 'online' },
    { label: 'Offline', value: 'ultima_conexao' },
    { label: 'Estoque', value: 'estoque' },
    { label: 'Todos', value: 'todos' }
  ],
  TECNOLOGIA: [
    { label: '2G', value: '2G' },
    { label: '3G', value: '3G' },
    { label: 'NB-IoT', value: 'NB' },
    { label: '4G', value: '4G' },
    { label: 'Outras', value: 'OUTRAS' },
    { label: 'Todos', value: 'todos' }
  ],
  TRAFEGO: [
    { label: 'Ativo', value: 'Ativo' },
    { label: 'Bloqueado', value: 'Bloqueado' },
    { label: 'Suspenso', value: 'Suspenso' },
    { label: 'Todos', value: 'todos' }
  ],
  PLANO_TIPO: [
    { label: 'Individual', value: 'Individual' },
    { label: 'Compartilhado', value: 'Compartilhado' },
    { label: 'Todos', value: 'todos' }
  ],
  ENVIO_SMS: [
    { label: 'Liberado', value: '1' },
    { label: 'Bloqueado', value: '0' },
    { label: 'Todos', value: 'todos' }
  ],
  TIPO_SIMCARD: [
    { label: 'Normal', value: 'Normal' },
    { label: 'Triplo corte', value: 'Triplo corte' },
    { label: 'Micro', value: 'Micro' },
    { label: 'Nano', value: 'Nano' },
    { label: 'Todos', value: 'todos' }
  ],
  PACOTE_EXTRA: [
    { label: 'Com', value: 'Com' },
    { label: 'Sem', value: 'Sem' },
    { label: 'Todos', value: 'todos' }
  ]
}

const DELETE_KEYS = [
  'CONEXOES_MIN',
  'CONEXOES_MAX',
  'PACOTES_MIN',
  'PACOTES_MAX',
  'CONSUMO_MIN',
  'CONSUMO_MAX',
  'SALDO_MAX',
  'AQUISICAO_FINAL',
  'ATIVACAO_FINAL',
  'DIAS_USADOS_MAX',
  'RANGE_ICCID_MAX',
  'PLANO_MAX'
]

const OPERADORA_OU_REDE = ['OPERADORA', 'REDE']
const CHAVES_PADROES = [
  'MARCA',
  'ULTIMA_CONEXAO',
  'TRAFEGO',
  'MODELO',
  'TECNOLOGIA',
  'TIPO_SIMCARD',
  'PACOTE_EXTRA',
  'PLANO_TIPO',
  'CLIENTE_FINAL_CODIGO',
  'CLIENTE_FINAL_NOME',
  'SMS_ATIVADO'
]
const DIAS_UTILIZADOS = ['DIAS_USADOS_MIN', 'RANGE_ICCID_MIN']
const GRUPO_OU_STATUS_CONTRATO = ['GRUPO', 'STATUS_CONTRATO']
const PACOTES_CONEXOES_CONSUMO = ['PACOTES', 'CONEXOES', 'CONSUMO']
const INTERVALO_DE_DATAS = [
  'ULTIMA_CONEXAO_INICIO',
  'ULTIMA_CONEXAO_FINAL',
  'AQUISICAO_INICIO',
  'ATIVACAO_INICIO'
]
const VALOR_MAX_MIN = ['VALOR_MIN', 'VALOR_MAX']

const STATUS_LABEL = {
  ultima_conexao: 'Offline',
  online: 'Online',
  estoque: 'Estoque'
}

//#endregion contants

//#region MAPS
const mapOperadora = (data) =>
  (data || []).map((item) => ({
    value: item.cd_dsp_operadora,
    label: item.ds_dsp_operadora
  }))

const mapSimcardTipo = (data) =>
  (data || []).map((item) => ({
    value: item.cd_dsp_simcard_tipo,
    label: item.ds_simcard_tipo
  }))

const mapGrupos = (data) =>
  (data || []).map((item) => ({
    value: item.cd_dsp_simcard_grupo,
    label: item.ds_nome
  }))

const mapRede = (data) =>
  (data || []).map((item) => ({
    value: item.CD_OPERADORA_REDE,
    label: item.REDE
  }))

const mapServicosAdicionais = (data) =>
  (data || []).map((item) => ({
    value: item.descricao1,
    label: item.descricao1
  }))

const mapMarcaModelo = (data) =>
  (data || []).map((item) => ({
    value: item.descricao1,
    label: item.descricao1
  }))

const mapStatusContrato = (data) =>
  (data || []).map((item) => ({
    value: item.CD_SITUACAO,
    label: item.SITUACAO
  }))

//#endregion MAPS

const formatarData = (data) => {
  if (!data) return

  return format(new Date(data), 'yyyy-MM-dd HH:mm:ss')
}

const formatarParaDatePicker = (data) => {
  return data ? formatDateToDatePicker(data) : undefined
}

export default function FiltroDispositivos({
  refModal,
  setRevelarDropFiltros,
  toggleRevelarDropFiltros
}) {
  const { setIsLoadingGlobal } = useGlobal()

  const [erroNosDados, setErroNosDados] = useState(false)
  const [filterOptions, setFilterOptions] = useState(MOCK_FILTROS)
  const [localFilters, setLocalFilters] = useState({
    ...DEFAULT_FILTERS_VALUES
  })

  const despacho = useDispatch()

  let recarregarBarraFiltragemValor = useSelector(
    (state) => state.filtrosState.recarregarBarraFiltragem
  )

  let filtros = useSelector((state) => state.filtrosState.filtros)

  const {
    getOperadoras,
    getSimcardTipo,
    getGruposPadroes,
    getGruposCliente,
    getRede,
    getConsultarDadosSelect,
    getStatusContrato
  } = DispositivosService

  const fetchFilters = async () => {
    const [
      operadora,
      simcardTipo,
      gruposPadroes,
      gruposCliente,
      rede,
      servicosAdicional,
      marca,
      modelo,
      statusContrato
    ] = await Promise.all([
      getOperadoras(),
      getSimcardTipo(),
      getGruposPadroes(),
      getGruposCliente(),
      getRede(),
      getConsultarDadosSelect('dsp_grupo_produto'),
      getConsultarDadosSelect('dsp_imei_modelo'),
      getConsultarDadosSelect('dsp_imei_marca'),
      getStatusContrato()
    ])

    const concatGrupos = [...gruposPadroes, ...gruposCliente]

    return {
      OPERADORA: mapOperadora(operadora),
      REDE: mapRede(rede),
      SIMCARD_TIPO: mapSimcardTipo(simcardTipo),
      GRUPO: mapGrupos(concatGrupos),
      SERVICOS_ADICIONAIS: mapServicosAdicionais(servicosAdicional),
      MARCA: mapMarcaModelo(marca),
      MODELO: mapMarcaModelo(modelo),
      STATUS_CONTRATO: mapStatusContrato(statusContrato)
    }
  }

  const queryClient = useQueryClient()

  const dadosEmCache = queryClient.getQueryData(['opcoes-filtros-dispositivos'])

  useEffect(() => {
    if (dadosEmCache) {
      setFilterOptions((prev) => ({
        ...prev,
        ...dadosEmCache
      }))
    }
  }, [dadosEmCache, setFilterOptions])

  useQuery(
    ['opcoes-filtros-dispositivos'],
    async () => {
      setIsLoadingGlobal(true)
      try {
        return await fetchFilters()
      } catch (err) {
        console.error(err)
      } finally {
        setIsLoadingGlobal(false)
      }
    },
    {
      onSuccess: (data) => {
        if (!data) return

        setFilterOptions((prev) => ({
          ...prev,
          ...data
        }))
      },
      staleTime: 600000, //* 10 minutos
      cacheTime: 600000, //* Mantém no cache por 10 minutos após ficar inativo
      keepPreviousData: true,
      refetchOnWindowFocus: false
    }
  )

  useEffect(() => {
    if (filtros.vazio) return

    const auxFilter = { ...DEFAULT_FILTERS_VALUES }

    const applyFilters = {
      padrao: {
        TECNOLOGIA: 'TECNOLOGIA',
        TRAFEGO: 'TRAFEGO',
        STATUS: 'ULTIMA_CONEXAO',
        PLANO_TIPO: 'PLANO_TIPO',
        TIPO_SIMCARD: 'TIPO_SIMCARD',
        PACOTE_EXTRA: 'PACOTE_EXTRA',
        SERVICOS_ADICIONAIS: 'SERVICO_ADICIONAL',
        MARCA: 'MARCA',
        MODELO: 'MODELO',
        ENVIO_SMS: 'SMS_ATIVADO',
        GRUPO: 'GRUPO',
        STATUS_CONTRATO: 'STATUS_CONTRATO'
      },
      array: {
        OPERADORA: () => filtros.OPERADORA?.split(',').map(Number),
        REDE: () => filtros.REDE?.split(',').map(Number)
      },
      intervalo: {
        VALOR: ['VALOR_MIN', 'VALOR_MAX'],
        DIAS_UTILIZADOS: ['DIAS_USADOS_MIN', 'DIAS_USADOS_MAX'],
        SALDO: ['SALDO_MIN', 'SALDO_MAX'],
        ICCID_INTERVALO: ['RANGE_ICCID_MIN', 'RANGE_ICCID_MAX']
      },
      periodo: {
        CONEXOES: ['CONEXOES', 'CONEXOES_MIN', 'CONEXOES_MAX'],
        PACOTES: ['PACOTES', 'PACOTES_MIN', 'PACOTES_MAX'],
        CONSUMO: ['CONSUMO', 'CONSUMO_MIN', 'CONSUMO_MAX']
      },
      dataRange: {
        ULTIMO_EVENTO: ['ULTIMA_CONEXAO_INICIO', 'ULTIMA_CONEXAO_FINAL'],
        AQUISICAO: ['AQUISICAO_INICIO', 'AQUISICAO_FINAL'],
        ATIVACAO: ['ATIVACAO_INICIO', 'ATIVACAO_FINAL']
      },
      clienteFinal: () => {
        if (filtros.CLIENTE_FINAL_CODIGO) {
          return {
            CODIGO_CLIENTE: filtros.CLIENTE_FINAL_CODIGO,
            TIPO: 'CODIGO_CLIENTE'
          }
        } else if (filtros.CLIENTE_FINAL_NOME) {
          return {
            NOME_CLIENTE: filtros.CLIENTE_FINAL_NOME,
            TIPO: 'NOME_CLIENTE'
          }
        }
      }
    }

    Object.entries(applyFilters.padrao).forEach(([key, filterKey]) => {
      if (filtros[filterKey]) auxFilter[key] = filtros[filterKey]
    })

    Object.entries(applyFilters.array).forEach(([key, getValue]) => {
      const value = getValue()
      if (value) auxFilter[key] = value
    })

    Object.entries(applyFilters.intervalo).forEach(
      ([key, [minKey, maxKey]]) => {
        if (filtros[minKey] || filtros[maxKey]) {
          auxFilter[key] = { MIN: filtros[minKey], MAX: filtros[maxKey] }
        }
      }
    )

    Object.entries(applyFilters.periodo).forEach(
      ([key, [periodKey, minKey, maxKey]]) => {
        if (filtros[periodKey]) {
          auxFilter[key] = {
            PERIODO: filtros[periodKey],
            MIN: filtros[minKey],
            MAX: filtros[maxKey]
          }
        }
      }
    )

    Object.entries(applyFilters.dataRange).forEach(
      ([key, [startKey, endKey]]) => {
        if (filtros[startKey] || filtros[endKey]) {
          auxFilter[key] = {
            DE: formatarParaDatePicker(filtros[startKey]),
            ATE: formatarParaDatePicker(filtros[endKey])
          }
        }
      }
    )

    const clienteFinal = applyFilters.clienteFinal()
    if (clienteFinal) auxFilter.CLIENTE_FINAL = clienteFinal

    setLocalFilters(auxFilter)
  }, [filtros])

  const handleCancelar = () => setRevelarDropFiltros(false)

  const handleLimparFiltros = () => {
    ColetaClickstream(1191) /*dropFiltrosLimpar*/

    setLocalFilters({ ...DEFAULT_FILTERS_VALUES })
    despacho(realizouFiltro(true))
    despacho(mudarFiltros({ vazio: 'vazio' }))
    despacho(revelarBarraFiltragem(false))
  }

  const montarFiltrosParaRedux = () => ({
    OPERADORA: formatArrayToString(localFilters?.OPERADORA),
    REDE: formatArrayToString(localFilters?.REDE),
    ULTIMA_CONEXAO: localFilters?.STATUS,
    TECNOLOGIA: localFilters?.TECNOLOGIA,
    TRAFEGO: localFilters?.TRAFEGO,
    CONEXOES: localFilters?.CONEXOES?.PERIODO,
    CONEXOES_MIN: localFilters?.CONEXOES?.MIN,
    CONEXOES_MAX: localFilters?.CONEXOES?.MAX,
    ULTIMA_CONEXAO_INICIO: formatarData(localFilters?.ULTIMO_EVENTO?.DE),
    ULTIMA_CONEXAO_FINAL: formatarData(localFilters?.ULTIMO_EVENTO?.ATE),
    PLANO_TIPO: localFilters?.PLANO_TIPO,
    SMS_ATIVADO: localFilters?.ENVIO_SMS,
    TIPO_SIMCARD: localFilters?.TIPO_SIMCARD,
    PACOTE_EXTRA: localFilters?.PACOTE_EXTRA,
    PACOTES: localFilters?.PACOTES?.PERIODO,
    PACOTES_MIN: localFilters?.PACOTES?.MIN,
    PACOTES_MAX: localFilters?.PACOTES?.MAX,
    VALOR_MIN: localFilters?.VALOR?.MIN,
    VALOR_MAX: localFilters?.VALOR?.MAX,
    DIAS_USADOS_MIN: localFilters?.DIAS_UTILIZADOS?.MIN,
    DIAS_USADOS_MAX: localFilters?.DIAS_UTILIZADOS?.MAX,
    AQUISICAO_INICIO: formatarData(localFilters?.AQUISICAO?.DE),
    AQUISICAO_FINAL: formatarData(localFilters?.AQUISICAO?.ATE),
    ATIVACAO_INICIO: formatarData(localFilters?.ATIVACAO?.DE),
    ATIVACAO_FINAL: formatarData(localFilters?.ATIVACAO?.ATE),
    SERVICO_ADICIONAL: localFilters?.SERVICOS_ADICIONAIS,
    CONSUMO: localFilters?.CONSUMO?.PERIODO,
    CONSUMO_MIN: localFilters?.CONSUMO?.MIN,
    CONSUMO_MAX: localFilters?.CONSUMO?.MAX,
    SALDO_MIN: localFilters?.SALDO?.MIN,
    SALDO_MAX: localFilters?.SALDO?.MAX,
    RANGE_ICCID_MIN: localFilters?.ICCID_INTERVALO?.MIN,
    RANGE_ICCID_MAX: localFilters?.ICCID_INTERVALO?.MAX,
    MODELO: localFilters?.MODELO,
    MARCA: localFilters?.MARCA,
    GRUPO: localFilters?.GRUPO,
    STATUS_CONTRATO: localFilters?.STATUS_CONTRATO,
    CLIENTE_FINAL_CODIGO: localFilters?.CLIENTE_FINAL?.CODIGO_CLIENTE,
    CLIENTE_FINAL_NOME: localFilters?.CLIENTE_FINAL?.NOME_CLIENTE
  })

  const handleFiltroOperadoraRede = (key, value, arrayFiltrosSimcard) => {
    const array = value.split(',').map(Number)
    array.forEach((valor) => {
      const items = filterOptions[key].find((f) => f.value === valor)
      if (key === 'REDE') {
        arrayFiltrosSimcard.push(`Rede: ${items.label} ${items.value}?REDE`)
        return
      }
      if (items) {
        arrayFiltrosSimcard.push(`${items.label} ${items.value}`)
      }
    })
  }

  const handleFiltroPadrao = (key, value, arrayFiltrosSimcard) => {
    const labels = {
      MARCA: `${value}?MARCA`,
      ULTIMA_CONEXAO: `${STATUS_LABEL[value]}?ULTIMA_CONEXAO`,
      PACOTE_EXTRA: `${value} pacote extra?PACOTE_EXTRA`,
      MODELO: `${value}?MODELO`,

      TECNOLOGIA:
        value === 'NB' ? 'NB-loT' + '?ULTIMA_CONEXAO' : `${value}?TECNOLOGIA`,
      TIPO_SIMCARD: `${value}?TIPO_SIMCARD`,
      PLANO_TIPO: `${value}?PLANO_TIPO`,
      SMS_ATIVADO:
        filterOptions.ENVIO_SMS.find((f) => f.value === value)?.label +
        '?SMS_ATIVADO'
    }

    arrayFiltrosSimcard.push(labels[key] || `${value}?${key}`)
  }

  const handleFiltroPlano = (finalFiltros, arrayFiltrosSimcard) => {
    const planoMin = finalFiltros['PLANO_MIN']
    const planoMax = finalFiltros['PLANO_MAX']

    if (planoMin && !planoMax) {
      arrayFiltrosSimcard.push(`Plano: a partir de R$ ${planoMin}?PLANO_MIN`)
    } else if (!planoMin && planoMax) {
      arrayFiltrosSimcard.push(`Plano: até R$ ${planoMax}?PLANO_MAX`)
    } else {
      arrayFiltrosSimcard.push(
        `Plano: entre ${planoMin} MB e ${planoMax} MB?PLANO_MIN`
      )
    }
  }

  const handleFiltroSaldo = (finalFiltros, arrayFiltrosSimcard) => {
    const saldoMin = finalFiltros['SALDO_MIN']
    const saldoMax = finalFiltros['SALDO_MAX']

    if (saldoMin && saldoMax) {
      arrayFiltrosSimcard.push(
        `Saldo: entre ${saldoMin} MB e ${saldoMax} MB?SALDO_MIN`
      )
    }
  }

  const handleFiltroValor = (finalFiltros, arrayFiltrosSimcard) => {
    const valorMin = finalFiltros['VALOR_MIN']
    const valorMax = finalFiltros['VALOR_MAX']

    if (valorMin && valorMax) {
      arrayFiltrosSimcard.push(
        `Valor: entre R$ ${valorMin} e R$ ${valorMax}?VALOR_MIN`
      )
    } else if (valorMin && !valorMax) {
      arrayFiltrosSimcard.push(`Valor: a partir de R$ ${valorMin}?VALOR_MIN`)
    } else if (!valorMin && valorMax) {
      arrayFiltrosSimcard.push(`Valor: até R$ ${valorMax}?VALOR_MAX`)
    }
  }

  const handleFiltroDiasUtilizados = (
    key,
    value,
    finalFiltros,
    arrayFiltrosSimcard
  ) => {
    const intervaloMap = {
      DIAS_USADOS_MIN: () =>
        `Dias utilizados: entre ${finalFiltros['DIAS_USADOS_MIN']} e ${finalFiltros['DIAS_USADOS_MAX']} dias?DIAS_USADOS_MIN`,
      RANGE_ICCID_MIN: () => {
        const iccidMin = finalFiltros['RANGE_ICCID_MIN']
        const iccidMax = finalFiltros['RANGE_ICCID_MAX']
        return iccidMin && !iccidMax
          ? `ICCID a partir de ${iccidMin}?RANGE_ICCID_MIN`
          : iccidMin && iccidMax
            ? `ICCID entre ${iccidMin} e ${iccidMax}?RANGE_ICCID_MIN`
            : `ICCID menor que ${iccidMax}?RANGE_ICCID_MIN`
      }
    }

    if (intervaloMap[key]) {
      arrayFiltrosSimcard.push(intervaloMap[key]())
    } else {
      arrayFiltrosSimcard.push(`${value}?${key}`)
    }
  }

  const handleFiltroPacotesConexoesConsumo = (
    key,
    value,
    finalFiltros,
    arrayFiltrosSimcard
  ) => {
    const labels = {
      CONEXOES: 'Conexões',
      CONSUMO: 'Consumo',
      PACOTES: 'Pacotes'
    }

    const minKey = `${key}_MIN`
    const maxKey = `${key}_MAX`
    const min = finalFiltros[minKey]
    const max = finalFiltros[maxKey]

    if (min && max) {
      const unidade = key === 'CONSUMO' ? ' MB' : ''
      arrayFiltrosSimcard.push(
        `${labels[key]} no ${value}: entre ${min} e ${max}${unidade}?${minKey}`
      )
    }
  }

  const handleFiltroIntervaloDeDatas = (
    key,
    finalFiltros,
    arrayFiltrosSimcard
  ) => {
    const labels = {
      ULTIMA_CONEXAO_INICIO: 'Último evento: período de',
      AQUISICAO_INICIO: 'Aquisição: entre',
      ATIVACAO_INICIO: 'Ativação : entre'
    }

    const isUltimaConexao =
      key === 'ULTIMA_CONEXAO_INICIO' || key === 'ULTIMA_CONEXAO_FINAL'
    const minKey = isUltimaConexao ? 'ULTIMA_CONEXAO_INICIO' : key
    const maxKey = isUltimaConexao
      ? 'ULTIMA_CONEXAO_FINAL'
      : key.replace('_INICIO', '_FINAL')

    const min = finalFiltros[minKey]
    const max = finalFiltros[maxKey]

    const conjuncao = key === 'ULTIMA_CONEXAO_INICIO' ? 'até' : 'e'

    if (min && max) {
      const templateString = `${labels[minKey]} ${formatDateToFilter(min)} ${conjuncao} ${formatDateToFilter(max)}?${minKey}`
      arrayFiltrosSimcard.push(templateString)
      return
    }

    if (min && !max) {
      arrayFiltrosSimcard.push(
        `Último evento: Período a partir de ${formatDateToFilter(min)}?ULTIMA_CONEXAO_INICIO`
      )
    } else if (!min && max) {
      arrayFiltrosSimcard.push(
        `Último evento: Período até ${formatDateToFilter(max)}?ULTIMA_CONEXAO_INICIO`
      )
    }
  }

  const handleFiltroGrupoStatusContrato = (
    key,
    value,
    filterOptions,
    arrayFiltrosSimcard
  ) => {
    const items = filterOptions[key].find((f) => f.value === value)
    const chaveFiltro = {
      GRUPO: 'GRUPO',
      STATUS_CONTRATO: 'CD_SITUACAO'
    }

    if (items) {
      arrayFiltrosSimcard.push(`${items.label}?${chaveFiltro[key]}`)
    }
  }

  const montarBarraFiltragem = (finalFiltros) => {
    const arrayFiltrosSimcard = []

    Object.entries(finalFiltros).forEach(([key, value]) => {
      if (DELETE_KEYS.includes(key)) return

      if (OPERADORA_OU_REDE.includes(key)) {
        handleFiltroOperadoraRede(key, value, arrayFiltrosSimcard)
      } else if (key === 'SERVICO_ADICIONAL') {
        arrayFiltrosSimcard.push(
          `Serviço Adicional: ${value}?SERVICO_ADICIONAL`
        )
      } else if (CHAVES_PADROES.includes(key)) {
        handleFiltroPadrao(key, value, arrayFiltrosSimcard)
      } else if (key === 'PLANO_MIN') {
        handleFiltroPlano(finalFiltros, arrayFiltrosSimcard)
      } else if (DIAS_UTILIZADOS.includes(key)) {
        handleFiltroDiasUtilizados(
          key,
          value,
          finalFiltros,
          arrayFiltrosSimcard
        )
      } else if (GRUPO_OU_STATUS_CONTRATO.includes(key)) {
        handleFiltroGrupoStatusContrato(
          key,
          value,
          filterOptions,
          arrayFiltrosSimcard
        )
      } else if (PACOTES_CONEXOES_CONSUMO.includes(key)) {
        handleFiltroPacotesConexoesConsumo(
          key,
          value,
          finalFiltros,
          arrayFiltrosSimcard
        )
      } else if (
        INTERVALO_DE_DATAS.includes(key) &&
        !arrayFiltrosSimcard.some((item) =>
          item.includes('Último evento: período de')
        )
      ) {
        handleFiltroIntervaloDeDatas(key, finalFiltros, arrayFiltrosSimcard)
      } else if (key === 'SALDO_MIN') {
        handleFiltroSaldo(finalFiltros, arrayFiltrosSimcard)
      } else if (
        VALOR_MAX_MIN.includes(key) &&
        !arrayFiltrosSimcard.some((item) => item.includes('Valor: entre'))
      ) {
        handleFiltroValor(finalFiltros, arrayFiltrosSimcard)
      }
    })

    return arrayFiltrosSimcard
  }

  const handleFiltrar = () => {
    const filtrosRedux = montarFiltrosParaRedux()

    const finalFiltros = Object.fromEntries(
      Object.entries(filtrosRedux).filter(
        ([, value]) => value && value !== 'todos'
      )
    )

    const arrayFiltrosSimcard = montarBarraFiltragem(finalFiltros)

    despacho(maximoTagsExibidas(setRevelarDropFiltros))
    despacho(filtrosArrayBarra(arrayFiltrosSimcard))
    despacho(revelarBarraFiltragem(true))
    despacho(recarregarBarraFiltragem(!recarregarBarraFiltragemValor))
    despacho(mudarFiltros(finalFiltros))
    toggleRevelarDropFiltros(false)
  }

  const validarDisabled = () => {
    if (erroNosDados) return true

    const { SALDO, CONEXOES, AQUISICAO, ATIVACAO } = localFilters

    if (SALDO && SALDO?.MIN && SALDO?.MAX) {
      if (
        !SALDO?.MIN ||
        !SALDO?.MAX ||
        SALDO?.MIN <= 0 ||
        SALDO?.MAX <= 0 ||
        SALDO?.MIN > SALDO?.MAX
      ) {
        return true
      }
    }

    if (
      CONEXOES &&
      (!CONEXOES?.MIN || !CONEXOES?.MAX || CONEXOES?.MAX < CONEXOES?.MIN)
    ) {
      return true
    }

    if (AQUISICAO && (AQUISICAO.DE !== null) !== (AQUISICAO.ATE !== null))
      return true
    if (ATIVACAO && (ATIVACAO.DE !== null) !== (ATIVACAO.ATE !== null))
      return true

    return false
  }

  return (
    <S.Modal ref={refModal}>
      <S.Container>
        <S.Seta />
        <S.Conteudo>
          <S.TituloWrapper>
            <S.Titulo>
              <S.Elipse src={ellipseVerde} alt="elipse" />
              <S.TituloModal>Filtros</S.TituloModal>
            </S.Titulo>
            <S.BotoesFiltroWrapper>
              <Botao
                label={
                  <S.LimparFiltroLabelWrapper onClick={handleLimparFiltros}>
                    <span>LIMPAR FILTROS</span>
                    <img src={limparFiltr()} alt="fechar-janela" />
                  </S.LimparFiltroLabelWrapper>
                }
                variant="unstyled"
              />
              <Botao
                disabled={validarDisabled()}
                label="Filtrar"
                variant="primary"
                onClick={handleFiltrar}
              />
              <Botao
                label="Voltar"
                variant="outline"
                onClick={handleCancelar}
              />
            </S.BotoesFiltroWrapper>
          </S.TituloWrapper>
          {Object.entries(FILTROS).map(([key, arrayGrupo]) => (
            <S.Grupo key={key}>
              {arrayGrupo.map((item) => (
                <Filtros
                  localFilters={localFilters}
                  setLocalFilters={setLocalFilters}
                  key={item}
                  nome={item}
                  opcoes={filterOptions}
                  setErroNosDados={setErroNosDados}
                />
              ))}
            </S.Grupo>
          ))}
        </S.Conteudo>
      </S.Container>
    </S.Modal>
  )
}
